"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var _DecoratorsRoot = require("../layout/DecoratorsRoot");

/**
 * useColors
 * 1: 網頁背景
 * 2: 選單背景
 * 3: 選單文字
 * 4: 網頁文字
 * 5: 主要按鈕
 * 6: 框線與分隔線
 * 7: 主要按鈕文字
 * @returns {Array}
 */
var useColors = function useColors() {
  var _useContext = (0, _react.useContext)(_DecoratorsRoot.EnhancerContext),
      colors = _useContext.colors;

  return colors;
};

var _default = useColors;
exports["default"] = _default;